'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AvailabilityMessage(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'div',
    {
      style: {
        fontSize: 11,
        marginTop: -6,
        // https://git.hubteam.com/HubSpot/conversations-team/issues/1059
        // We are extending this component so that it spans the width of the widget.
        // We will revisit this when the widget layout is refactored in 499:
        // https://git.hubteam.com/HubSpot/conversations-team/issues/499.
        marginLeft: -50,
        marginRight: -50
      }
    },
    children
  );
}

AvailabilityMessage.propTypes = {
  children: _react.PropTypes.string.isRequired
};

exports.default = AvailabilityMessage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/AvailabilityMessage.js
// module id = 1050
// module chunks = 2 3